import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'activityDomaine'
})
export class ActivityDomaine implements PipeTransform {

  transform(value: any): string {

    if (['Users'].includes(value)) {
      return 'Utilisateurs';
    }

    if (['Groups', 'UserGroups'].includes(value)) {
      return 'Groupes';
    }

    if (['Assets'].includes(value)) {
      return 'Références';
    }

    if (['EmailTemplates'].includes(value)) {
      return 'Templates email';
    }

    if (['ApprovalWorkflows'].includes(value)) {
      return 'Flux d\'approbations';
    }

    if (['Workflows'].includes(value)) {
      return 'Flux de validations';
    }

    if (['RecipientEntities'].includes(value)) {
      return 'Sociétés';
    }

    return value;
  }
}